import _ from 'lodash';
import { mapState } from 'vuex';
import { creative, SearchTable, permissions } from '~';

const endpoint = creative.endpoint;
const enabledFields = creative.enabledFields;
const availableFilters = creative.availableFilters;
const enabledFieldsSM = creative.enabledFieldsSM;

export default {
  components: {
    'search-table': SearchTable,
  },
  computed: {
    ...mapState('auth', { currentUser: 'user' }),
    ...mapState('publicConfig', ['config']),
    disabledFields() {
      return _.get(this.config, 'disabled_columns.lab.creatives', []);
    },
    options() {
      const enabledFilterFields = [
        ['createdAt', 'campaignName', 'statuses', 'type'],
        ['customer', 'numberOfReworks', 'daysInCurrentStatus', 'onlyForActiveCampaigns', 'clientLanguage'],
      ];
      const availableFields = creative.availableFields(this.disabledFields);

      if (permissions.canGlobal(this.currentUser, 'Creative', ['filterRejectReason'])) {
        enabledFilterFields[1].push('rejectReasons');
      } else if (availableFields.reject_reason_categories) {
        delete availableFields.reject_reason_categories;
      }

      if (!_.get(this.config, 'has_onboarding_flow', true)) {
        delete availableFields.number_of_calls;
        delete availableFields.second_call_date;
        delete availableFields.onboarded;
      }

      return {
        endpoint,
        fields: availableFields,
        enabledFields,
        enabledFieldsSM,
        availableFilters,
        enabledFilters: enabledFilterFields,
      };
    },
  },
  methods: {
    openItemUrl(item) {
      return { name: 'creative', params: { id: item.id } };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/creatives/Creatives.js